import { render, staticRenderFns } from "./ListaTalento.vue?vue&type=template&id=00ba1d84"
import script from "./ListaTalento.vue?vue&type=script&lang=js"
export * from "./ListaTalento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports